import React, { useState, useEffect } from 'react';
import { Row, Col, Space, Typography, Tooltip, Select, message } from 'antd';
import { Text } from '../../../../components/Text';
import interrogation from '../../../../assets/icons/interrogation.svg';

import * as S from './styles';
import { SelectMultiplo } from '../../../../components/SelectMultiplo';
import api from '../../../../services/api';
import { CardDocumentosConjunto } from './components/CardDocumentosConjunto';
import { ButtonCorrecaoTransSat } from './components/ButtonCorrecaoTransSat';
import { AnaliseReferencias } from './components/AnaliseReferencias';
import { AnexarDocumentoConsulta } from './components/AnexarDocumentoConsulta';

const { Link } = Typography;
const { Option } = Select;
let timeoutRazao;

export function Content({
  data,
  setSpinning,
  setChangeText,
  textAreaValue,
  adicionarDescricaoRazao,
  consultasComRazoesVinculadas = [],
  setConsultasComRazoesVinculadas,
  razoesConsultaSolicitacao = [],
  idEStatus,
  validacaoManualConsulta,
  carregarSolicitacaoAtual,
}) {
  const existeRazoes = data?.razoesReprovacaoConsulta.length > 0;
  const consultaComReferencias = [13, 29].includes(data?.idConsulta);
  const permiteAnexarArquivo = [12, 18].includes(data?.idConsulta);

  const [idIntegracaoFornecedor, setIdIntegracaoFornecedor] = useState(
    data?.idIntegracaoFornecedor
  );

  const [initialStateRazoes, setInitialStateRazoes] = useState(
    razoesConsultaSolicitacao
  );

  const [razoesVinculadas, setRazoesVinculadas] = useState(
    razoesConsultaSolicitacao ?? []
  );

  const timeout = () => (
    <Tooltip placement="right" title="Tempo esgotado">
      <span style={{ cursor: 'default' }}>
        Timeout
        <img
          style={{ width: '12px', height: '12px', marginTop: '-2px' }}
          src={interrogation}
          alt="img"
        />
      </span>
    </Tooltip>
  );

  const vincularIdConsultaRazao = () => {
    if (razoesVinculadas.length === 0) {
      setConsultasComRazoesVinculadas(
        consultasComRazoesVinculadas.filter(x => x !== data?.id)
      );
    } else if (
      !razoesVinculadas.some(r =>
        consultasComRazoesVinculadas.includes(r.idConsultaSolicitacao)
      )
    ) {
      setConsultasComRazoesVinculadas(
        consultasComRazoesVinculadas.concat(data?.id)
      );
    }
  };

  const vincularRazaoReprovacao = async () => {
    setSpinning(true);

    if (!razoesVinculadas) return;
    vincularIdConsultaRazao();
    const IdsRazoesReprovacao = razoesVinculadas.map(x => x.idRazaoReprovacao);
    const payload = {
      IdConsultaSolicitacao: data?.id,
      IdsRazoesReprovacao,
    };

    try {
      await api.post(
        'SolicitacaoAtendimento/vincular-razao-reprovacao',
        payload
      );
      message.success(
        IdsRazoesReprovacao.length > 0
          ? 'Razão de reprovação vinculada com sucesso.'
          : 'Razão de reprovação removida com sucesso.'
      );

      adicionarDescricaoRazao(razoesVinculadas);

      setSpinning(false);
    } catch (error) {
      message.error(
        error?.response?.data?.detail ||
          'Falha ao vincular a razão de reprovação na consulta.'
      );
      setSpinning(false);
    }
  };

  const handleChangeOption = e => {
    const idsRazoes = razoesVinculadas
      .filter(
        x =>
          x.idConsulta === data.idConsulta &&
          x.idConsultaSolicitacao === data?.id
      )
      .map(r => r.idRazaoReprovacao);
    const ids = e.filter(id => !idsRazoes.includes(id));
    const razoes = data?.razoesReprovacaoConsulta.filter(x =>
      ids.includes(x.idRazaoReprovacao)
    );
    const result = razoes.map(razao => ({
      ...razao,
      idConsultaSolicitacao: data?.id,
    }));

    setRazoesVinculadas(razoesVinculadas.concat(result));
  };

  const handleDeleteOption = e => {
    let texto = textAreaValue;
    if (texto) {
      texto = texto.replace(
        razoesVinculadas
          .filter(razao => razao.idRazaoReprovacao === e)
          .map(r => r.descricao),
        ''
      );
    }
    setChangeText(texto);
    setRazoesVinculadas(
      razoesVinculadas.filter(
        x => x.idRazaoReprovacao !== e && x.idConsultaSolicitacao === data?.id
      )
    );
  };

  const handleChangeSolicitarAlteracaoCelular = async value => {
    setSpinning(true);

    const payload = {
      IdConsultaSolicitacao: data?.id,
      solicitaAlteracaoCelular: value,
    };

    try {
      await api.post(
        'SolicitacaoAtendimento/solicitar-alteracao-celular',
        payload
      );

      message.success(
        `Solicitação de alteração de celular ${
          value ? 'realizada' : 'cancelada'
        } com sucesso.`
      );

      setSpinning(false);
    } catch (error) {
      message.error(
        error?.response?.data?.detail ||
          'Erro ao atualizar a solicitação de alteração de celular.'
      );
      setSpinning(false);
    }
  };

  const handleDocumentoAnexado = idDocumento => {
    data.idIntegracaoFornecedor = idDocumento;
    setIdIntegracaoFornecedor(idDocumento);
  };

  useEffect(() => {
    if (
      JSON.stringify(razoesVinculadas) === JSON.stringify(initialStateRazoes)
    ) {
      return;
    }
    if (razoesVinculadas.length === 0) {
      validacaoManualConsulta(data?.id);
    }
    setInitialStateRazoes(null);
    const setTimeoutRazao = async () => {
      if (timeoutRazao) {
        clearTimeout(timeoutRazao);
        timeoutRazao = null;
      }

      await Promise.all([
        (timeoutRazao = setTimeout(vincularRazaoReprovacao, 1000)),
      ]);
    };

    setTimeoutRazao();
  }, [razoesVinculadas]);

  return (
    <S.Content>
      <Col span={24}>
        <S.TitleContent weight="bold">
          {data.tipoDivergencia}
{' '}
{data.idStatus === 5 ? timeout() : ''}
        </S.TitleContent>
        <Row
          style={{
            display: 'flex',
            flexDirection: 'row',
            marginBottom: 8,
          }}
        >
          {data?.criticaConsulta && (
            <S.TitleContent red="#D42929">
              <pre>{data?.criticaConsulta || ''}</pre>
            </S.TitleContent>
          )}
        </Row>
        <Row
          justify="space-between"
          style={{
            margin: '21px 0 14px 0',
          }}
        >
          <S.Title color="#707070">
            <pre>{data.orientacaoValidacaoConsulta}</pre>
          </S.Title>
{' '}
        </Row>
        <Row justify="start" gutter={[2, 8]}>
          {consultaComReferencias ? (
            <Col span={24}>
              <AnaliseReferencias
                idConsultaSolicitacao={data?.id}
                nomeConsulta={data?.nomeConsulta}
                orientacao={data?.orientacaoValidacaoConsulta}
              />
            </Col>
          ) : (
            data?.itensValidacaoConsulta?.map((referencia, index) => (
              <Col span={8} key={index}>
                <Text
                  title={referencia?.nome || ''}
                  value={referencia?.valor || ''}
                />
              </Col>
            ))
          )}
        </Row>
        <Row gutter={[2, 8]}>
          {data?.linkValidacaoConsulta && (
            <Row justify="start">
              <Col>
                <Space>
                  <S.Title>Local de validação:</S.Title>
                  <Link
                    underline
                    style={{
                      color: '#24A95D',
                    }}
                    href={data?.linkValidacaoConsulta || ''}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Acessar o site
                  </Link>
                </Space>
              </Col>
            </Row>
          )}
        </Row>

        {data.documentos?.length > 0 && (
          <CardDocumentosConjunto
            documentos={data.documentos}
            exibirDataValidade={[25, 28].includes(data?.idConsulta)}
          />
        )}

        {permiteAnexarArquivo && (
          <Row justify="start" style={{ marginTop: '8px' }}>
            <Col>
              <AnexarDocumentoConsulta
                idConsultaSolicitacao={data?.id}
                idIntegracaoFornecedor={idIntegracaoFornecedor}
                onDocumentoAnexado={handleDocumentoAnexado}
              />
            </Col>
          </Row>
        )}

        <Row justify="start" style={{ marginTop: '8px' }}>
          {existeRazoes && (
            <Col span={12}>
              <S.Title>Razão da reprovação</S.Title>
              <SelectMultiplo
                showArrow
                iconColor="red"
                disabled={idEStatus.status === 7}
                onChange={handleChangeOption}
                onDeselect={handleDeleteOption}
                defaultValue={() =>
                  data?.razoesReprovacaoConsulta
                    ?.filter(x => x.assinalado)
                    ?.map(x => x.idRazaoReprovacao)
                }
                style={{ cursor: 'pointer', width: '90%' }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {data?.razoesReprovacaoConsulta?.map((item, index) => (
                  <Option value={item.idRazaoReprovacao} key={index}>
                    {item?.razao}
                  </Option>
                ))}
              </SelectMultiplo>
            </Col>
          )}

          {data.idConsulta == 18 && (
            <Col span={12}>
              <S.Title>Solicitar alteração de celular</S.Title>
              <S.RowStyles style={{ width: '90%' }}>
                <Select
                  disabled={idEStatus.status === 7}
                  showArrow
                  onChange={handleChangeSolicitarAlteracaoCelular}
                  defaultValue={data?.solicitaAlteracaoCelular}
                  style={{ cursor: 'pointer', width: '100%' }}
                >
                  <Option value={false}>Não</Option>
                  <Option value={true}>Sim</Option>
                </Select>
              </S.RowStyles>
            </Col>
          )}
        </Row>

        {data?.idConsulta === 27 && data?.recomendada === null && (
          <ButtonCorrecaoTransSat
            idConsultaSolicitacao={data?.id}
            idStatusConsulta={data?.idStatus}
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
          />
        )}
      </Col>
    </S.Content>
  );
}
